import * as React from 'react';
import { DirectionalHint, IconButton, Stack, Text, TooltipDelay, TooltipHost } from '@fluentui/react';
import { lightTheme } from '../themes';

let nextTooltipId = 0;

interface LabelWithInfoProps {
    label: string,
    info: string,
    required?: boolean
}

export class LabelWithInfo extends React.Component<LabelWithInfoProps, {}> {
    private readonly tooltipId = `label-info-tooltip-${nextTooltipId++}`;

    render(): JSX.Element {
        return <>
            <Stack horizontal verticalAlign="center" styles={{ root: { padding: '5px 0' } }}>
                <Text styles={{ root: { fontWeight: 600 } }}>{this.props.label}</Text>
                {this.props.required && <Text styles={{ root: { color: lightTheme.semanticColors.errorText, fontWeight: 600, paddingLeft: 4 } }}>*</Text>}
                <TooltipHost
                    id={this.tooltipId}
                    content={this.props.info}
                    directionalHint={DirectionalHint.rightCenter}
                    delay={TooltipDelay.zero}
                    styles={{ root: { display: 'flex', marginLeft: 5 } }}
                >
                    <IconButton
                        iconProps={{ iconName: 'Info' }}
                        ariaLabel={`More information about ${this.props.label}`}
                        aria-describedby={this.tooltipId}
                        styles={{ root: { color: 'grey', width: 16, height: 16 }, icon: { fontSize: 14, height: 14 } }}
                    />
                </TooltipHost>
            </Stack>
        </>
    }
}